export const nav = {
    permissao: "lpbuilder.modelos_secoes:visualizar",
    section: "LPBuilder",
    title: "ModelosSecao",
    icon: "view_quilt",
    route: "/modelos-secao",
    sequence: 3,
};
export default [
    {
        path: "/modelos-secao",
        name: "lpbuilder-modelos-secao",
        component: () => import("./pages/ModelosSecaoPage.vue"),
        meta: {
            requiresAuth: true,
            permissao: "lpbuilder.modelos_secoes:visualizar",
        },
    },
];
